var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "inspectOrder" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 45, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "条形码", "label-width": 60 } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 13, clearable: true },
                            on: {
                              input: function ($event) {
                                return _vm.toInt()
                              },
                            },
                            model: {
                              value: _vm.search.barCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "barCode", $$v)
                              },
                              expression: "search.barCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "姓名" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 50, clearable: true },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "证件号码", "label-width": 75 } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { maxlength: 18, clearable: true },
                            model: {
                              value: _vm.search.idCard,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "idCard", $$v)
                              },
                              expression: "search.idCard",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "体检任务", "label-width": 75 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "min-width": "350px" },
                              attrs: {
                                placeholder: "体检任务",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.taskId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "taskId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.taskId",
                              },
                            },
                            _vm._l(_vm.taskList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { "min-width": "350px" },
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "5" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "学校" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "学校名称",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: { change: _vm.changeSchool },
                              model: {
                                value: _vm.search.schoolId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "schoolId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.schoolId",
                              },
                            },
                            _vm._l(_vm.schoolsList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "年级" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "年级",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: { change: _vm.changeGrade },
                              model: {
                                value: _vm.search.gradeId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "gradeId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.gradeId",
                              },
                            },
                            _vm._l(_vm.gradeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "班级" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "班级",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.classesId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "classesId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.classesId",
                              },
                            },
                            _vm._l(_vm.classesList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "拒检" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "80px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.rejectStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "rejectStatus", $$v)
                                },
                                expression: "search.rejectStatus",
                              },
                            },
                            _vm._l(_vm.rejectStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "抽血" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "95px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.checkStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "checkStatus", $$v)
                                },
                                expression: "search.checkStatus",
                              },
                            },
                            _vm._l(_vm.checkStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "抽血加项", "label-width": 75 } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "80px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.optionsStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "optionsStatus", $$v)
                                },
                                expression: "search.optionsStatus",
                              },
                            },
                            _vm._l(_vm.optionsStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "数据" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "80px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.dataStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "dataStatus", $$v)
                                },
                                expression: "search.dataStatus",
                              },
                            },
                            _vm._l(_vm.dataStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "异常" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.errorStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "errorStatus", $$v)
                                },
                                expression: "search.errorStatus",
                              },
                            },
                            _vm._l(_vm.errorStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "110px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.inspectStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "inspectStatus", $$v)
                                },
                                expression: "search.inspectStatus",
                              },
                            },
                            _vm._l(_vm.inspectStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "抽血日期", "label-width": 75 } },
                        [
                          _c("DatePicker", {
                            staticStyle: { width: "114px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "起始日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changestart },
                            model: {
                              value: _vm.search.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "startDate", $$v)
                              },
                              expression: "search.startDate",
                            },
                          }),
                          _c("DatePicker", {
                            staticStyle: { width: "114px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "结束日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changeend },
                            model: {
                              value: _vm.search.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "endDate", $$v)
                              },
                              expression: "search.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Row", [
        _c("div", { staticStyle: { "margin-top": "5px", width: "100%" } }, [
          _c(
            "div",
            { staticStyle: { float: "left" } },
            [
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchPush },
                },
                [_vm._v("全部推送")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchPull },
                },
                [_vm._v("全部拉取")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchCancel },
                },
                [_vm._v("全部取消")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.batchClear },
                },
                [_vm._v("全部清空")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { float: "right", "margin-right": "15px" } },
            [
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.batchBloodDraw()
                    },
                  },
                },
                [_vm._v("一键抽血")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "error" },
                  on: {
                    click: function ($event) {
                      return _vm.batchCancelBloodDraw()
                    },
                  },
                },
                [_vm._v("一键取消抽血")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.batchReject()
                    },
                  },
                },
                [_vm._v("一键拒检")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "error" },
                  on: {
                    click: function ($event) {
                      return _vm.batchCancelReject()
                    },
                  },
                },
                [_vm._v("一键取消拒检")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.batchPrint()
                    },
                  },
                },
                [_vm._v("打印报告")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.importData()
                    },
                  },
                },
                [_vm._v("导入检验")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "default" },
                  on: { click: _vm.batchExport },
                },
                [_vm._v("导出名单")]
              ),
              _c(
                "Button",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.bloodTest()
                    },
                  },
                },
                [_vm._v("导出健促血检")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: {
            "row-click": _vm.selectrow,
            "selection-change": _vm.selectList,
          },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "left", type: "selection", width: "25" },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "taskName",
              label: "体检任务",
              "min-width": "230",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "barCode",
              label: "条形码",
              "min-width": "130",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: "danger",
                              "disable-transitions": "",
                            },
                          },
                          [_vm._v("待审核生成")]
                        )
                      : _vm._e(),
                    row.status !== 1
                      ? _c("span", [_vm._v(_vm._s(row.barCode))])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "姓名",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "idCard",
              label: "证件号码",
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "phone",
              label: "手机号码",
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "schoolName",
              label: "学校",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "gradeName",
              label: "年级",
              "show-overflow-tooltip": "",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "classesName",
              label: "班级",
              "show-overflow-tooltip": "",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "birthday",
              label: "出生日期",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "checkStatus",
              label: "抽血",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type:
                            row.checkStatus === 2
                              ? "warning"
                              : row.checkStatus === 3
                              ? "primary"
                              : "danger",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.checkStatusList.filter(
                                (u) => u.value === row.checkStatus
                              )[0].label
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "rejectStatus",
              label: "拒检",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: row.rejectStatus === 2 ? "danger" : "primary",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.rejectStatus === 1
                                ? "未拒检"
                                : row.rejectStatus === 2
                                ? "已拒检"
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "optionsStatus",
              label: "抽血加项",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type:
                            row.optionsStatus === 1
                              ? "primary"
                              : row.optionsStatus === 2
                              ? "success"
                              : "",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.optionsStatus === 1
                                ? "无加项"
                                : row.optionsStatus === 2
                                ? "有加项"
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "drawBloodDate",
              label: "抽血日期",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.drawBloodDate
                      ? _c("i", { staticClass: "el-icon-time" })
                      : _vm._e(),
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(_vm._s(row.drawBloodDate)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "dataStatus",
              label: "数据状态",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type:
                            row.dataStatus === 1
                              ? "danger"
                              : row.dataStatus === 2
                              ? "warning"
                              : "primary",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.dataStatus === 1
                                ? "无数据"
                                : row.dataStatus === 2
                                ? "漏项"
                                : row.dataStatus === 3
                                ? "已完整"
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "inspectStatus",
              label: "状态",
              "show-overflow-tooltip": "",
              "min-width": "110",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type:
                            row.inspectStatus === 2
                              ? "success"
                              : row.inspectStatus === 6 ||
                                row.inspectStatus === 10
                              ? "primary"
                              : row.inspectStatus === 7 ||
                                row.inspectStatus === 9
                              ? "warning"
                              : row.inspectStatus === 3 ||
                                row.inspectStatus === 5 ||
                                row.inspectStatus === 8
                              ? "danger"
                              : "info",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.inspectStatusList.filter(
                                (u) => u.value === row.inspectStatus
                              )[0].label
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "reason",
              label: "原因",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "abnormal",
              label: "异常",
              "min-width": "350",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "remark",
              label: "备注",
              "min-width": "300",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "bloodTubeRemark",
              label: "试管",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "updateTime",
              label: "更新时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "250",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.dataStatus === 1 &&
                    row.checkStatus != 3 &&
                    row.rejectStatus == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.batchBloodDraw(row.barCode, row.name)
                              },
                            },
                          },
                          [_vm._v("抽血")]
                        )
                      : _vm._e(),
                    row.dataStatus === 1 && row.checkStatus != 1
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.batchCancelBloodDraw(
                                  row.barCode,
                                  row.name
                                )
                              },
                            },
                          },
                          [_vm._v("取消抽血")]
                        )
                      : _vm._e(),
                    row.dataStatus === 1 &&
                    row.checkStatus == 1 &&
                    row.rejectStatus == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.batchReject(row.barCode, row.name)
                              },
                            },
                          },
                          [_vm._v("拒检")]
                        )
                      : _vm._e(),
                    row.dataStatus === 1 && row.rejectStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.batchCancelReject(
                                  row.barCode,
                                  row.name
                                )
                              },
                            },
                          },
                          [_vm._v("取消拒检")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.detail(row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    row.dataStatus > 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.inspect(row)
                              },
                            },
                          },
                          [_vm._v("检验")]
                        )
                      : _vm._e(),
                    row.checkStatus !== 1 && row.dataStatus !== 3
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.push(row)
                              },
                            },
                          },
                          [_vm._v("推送")]
                        )
                      : _vm._e(),
                    row.inspectStatus === 2 || row.inspectStatus === 5
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.cancel(row)
                              },
                            },
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    row.checkStatus !== 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.pull(row)
                              },
                            },
                          },
                          [_vm._v("拉取")]
                        )
                      : _vm._e(),
                    row.dataStatus > 1
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.clear(row)
                              },
                            },
                          },
                          [_vm._v("清空")]
                        )
                      : _vm._e(),
                    row.checkStatus !== 1 && row.dataStatus > 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.print(row)
                              },
                            },
                          },
                          [_vm._v("打印")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.inspectTitle,
            visible: _vm.dialogTableVisible,
            fullscreen: false,
            "destroy-on-close": true,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.inspectList,
                stripe: "",
                "tooltip-effect": "dark",
                "header-cell-style": {
                  background: "#f8f8f9",
                  color: "#515a6e",
                  "text-align": "center",
                },
                "highlight-current-row": "",
                "highlight-selection-row": "",
                "row-key": "id",
                "max-height": _vm.tableHeight,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  align: "center",
                  prop: "name",
                  label: "姓名",
                  "min-width": "90",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  align: "center",
                  prop: "groupName",
                  label: "分组名称",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  align: "center",
                  prop: "itemName",
                  label: "项目明细",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  align: "center",
                  prop: "itemValue",
                  label: "检查结果",
                  "min-width": "70",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "unit",
                  label: "单位",
                  "min-width": "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "notice",
                  label: "提示",
                  "min-width": "40",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "ranges",
                  label: "参考值",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "submitter", label: "检验人" },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "auditor", label: "审核人" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "reportDate",
                  label: "报告时间",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "sources", label: "来源" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          _vm._s(
                            row.sources === 1
                              ? "拉取"
                              : row.sources === 2
                              ? "导入"
                              : row.sources === 3
                              ? "手动修改"
                              : ""
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "operator",
                  label: "操作人",
                  "min-width": "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "createTime",
                  label: "操作时间",
                  "min-width": "120",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            width: "50%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
            "footer-hide": "",
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("InspectOrderPageEdit", {
            ref: "edit",
            style: { "overflow-y": "auto" },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.importTitle,
            visible: _vm.importWindow,
            width: "400px",
            "custom-class": "my-dialog",
            "destroy-on-close": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importWindow = $event
            },
          },
        },
        [
          _c(
            "el-upload",
            {
              ref: "refUpload",
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                limit: 1,
                drag: "",
                multiple: "",
                "auto-upload": false,
                "on-change": _vm.handleChange,
                "on-remove": _vm.handleRemove,
                "file-list": _vm.fileList,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")]),
              ]),
            ]
          ),
          _c("div", [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.template()
                  },
                },
              },
              [_vm._v("文件模版")]
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancle } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.importDisabled },
                  on: { click: _vm.handleUpload },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a",
        {
          directives: [
            {
              name: "print",
              rawName: "v-print",
              value: _vm.printLisContent,
              expression: "printLisContent",
            },
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          attrs: { id: "printLis" },
        },
        [_vm._v("打印")]
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [
          _c("printInspectOrder", {
            ref: "printInspectOrder",
            attrs: { printData: _vm.printData },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }